import React, { Component } from 'react'
import ProfessionDetail from '../Profession/Detail'
import './ProfessionDetail.less'
import backIcon from "../../assets/ic_fanhui.png";

class Detail extends Component {

  handleBack() {
    const { history } = this.props
    history.push(`/majorwishlist`)
  }

  render() {
    return (
      <div className="profession-wish-list-wrapper">
        <header>
          <div className = "home-container">
            <div className="back" onClick={()=>{window.history.back()}}>
              <img src={backIcon} alt=""/>
              返回
            </div>
          </div>
        </header>
        <ProfessionDetail isRenderBackBtn={false} {...this.props} />
        {/*<div className="bottom-btn">*/}
        {/*  <button className="primary full" onClick={this.handleBack.bind(this)}>返回我的专业意向清单</button>*/}
        {/*</div>*/}
      </div>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/pages/MajorWishListNew/ProfessionDetail.js